import { css, cx } from 'linaria';
import { cssTheme } from '@uds/theme-utils';

import { DomainSearchDesignProps } from '../models/types';

const root = css`
  width: 100%;
  margin: 0;
  transition: margin-top 500ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
  margin-top: ${cssTheme.gu4};
  margin-bottom: ${cssTheme.gu4};

  ${cssTheme.breakpoints.sm} {
    margin-top: ${cssTheme.gu5};
    margin-bottom: ${cssTheme.gu5};
  }

  ${cssTheme.breakpoints.lg} {
    margin-top: ${cssTheme.gu6};
    margin-bottom: ${cssTheme.gu6};
  }
`;

const content = css`
  display: flex;
  flex-direction: column;
  padding: ${cssTheme.gu3};

  ${cssTheme.breakpoints.lg} {
    padding: ${cssTheme.gu4};
  }
`;

const collapsePaddingTop = css`
  margin-top: 0;
`;

const collapsePaddingBottom = css`
  margin-bottom: 0;
`;

const text = css`
  margin-bottom: ${cssTheme.gu3};
`;

const alignmentStarting = css`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

const alignmentCenter = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const searchInputWrapper = css`
  padding-top: 0;
`;

const rootWrapper = css`
  position: relative;
  margin-top: 0;
`;

const dstSubmitCTA = css`
  background-color: ${cssTheme.palette.cta};
  color: ${cssTheme.palette.ctaContrast};
`;

export const getClassNames = ({ design }: { design: DomainSearchDesignProps }) => ({
  text: cx(text, design?.alignment === 'start' ? alignmentStarting : alignmentCenter),
  root: cx(
    root,
    design?.collapsePadding?.top === true && collapsePaddingTop,
    design?.collapsePadding?.bottom === true && collapsePaddingBottom,
  ),
  rootWrapper,
  content,
  searchInputWrapper,
  dstSubmitCTA,
});
